import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const AngleRightIcon = ({
  color = '#B5BCBD',
  className,
  width = '14',
  height = '24',
}) => (
  <svg
    viewBox="0 0 14 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
  >
    <path
      fill={color}
      d="M2.1.1L0 2.2l8.3 8.3L9.8 12l-1.5 1.5L0 21.8l2.1 2.1L14 12z"
    />
  </svg>
);

AngleRightIcon.propTypes = propTypes;

export default AngleRightIcon;
